"use client"

import { CollectionResults } from "@/components/collection-results"
import { useSearchParams } from "next/navigation"

interface ResultsPageProps {
  wallet?: string
}

export default function ResultsPage({ wallet: initialWallet }: ResultsPageProps) {
  const searchParams = useSearchParams()
  const wallet = initialWallet || searchParams.get("wallet") || ""

  return (
    <main className="flex flex-1 flex-col items-center p-4 md:p-8 lg:p-12 pt-24 md:pt-28 lg:pt-32">
      <div className="w-full h-full">
        <CollectionResults walletAddress={wallet} />
      </div>
    </main>
  )
} 